import React, { Component } from "react";
import PropTypes from "prop-types";
import CssTransitionGroup from "react-transition-group/CSSTransitionGroup";
import Str from "shared/components/Str";
import classnames from "classnames";

import {
	BINARY_ANSWER_NO,
	BINARY_ANSWER_YES,
} from "apps/questions/util/constants";

import "./BinaryQuestion.scss";

const BUTTON_ANIMATION_TIME = 600;

class BinaryQuestion extends Component {
	static propTypes = {
		question: PropTypes.object.isRequired,
		onSubmit: PropTypes.func.isRequired,
		onSkip: PropTypes.func.isRequired,
		isProcessing: PropTypes.bool,
	};

	constructor(props) {
		super(props);

		this.state = {
			justPressedYes: false,
			justPressedNo: false,
		};
	}

	componentWillUnmount() {
		clearTimeout(this._TIMEOUT);
	}

	_handleSkip = () => {
		if (this.props.isProcessing) {
			return;
		}

		this.props.onSkip();
	}

	_handleNo = () => {
		if (this.props.isProcessing) {
			return;
		}

		this.setState({ justPressedNo: true });

		this._TIMEOUT = setTimeout(() => {
			this.setState({ justPressedNo: false });
		}, BUTTON_ANIMATION_TIME);

		this.props.onSubmit({
			id: this.props.question.qid,
			answer: BINARY_ANSWER_NO,
		});
	}

	_handleYes = () => {
		if (this.props.isProcessing) {
			return;
		}

		this.setState({ justPressedYes: true });

		this._TIMEOUT = setTimeout(() => {
			this.setState({ justPressedYes: false });
		}, BUTTON_ANIMATION_TIME);

		this.props.onSubmit({
			id: this.props.question.qid,
			answer: BINARY_ANSWER_YES,
		});
	}

	render() {
		const { qtext, qid } = this.props.question;
		const { justPressedNo, justPressedYes } = this.state;

		const noClasses = classnames({
			"binary-question-no": true,
			"binary-question-button": true,
			"flatbutton red": true,
			showIcon: justPressedNo,
		});

		const yesClasses = classnames({
			"binary-question-yes": true,
			"binary-question-button": true,
			"flatbutton green": true,
			showIcon: justPressedYes,
		});

		return (
			<div className="binary-question">
				<CssTransitionGroup
					transitionName="binary-question-text-transition"
					transitionEnterTimeout={300}
					transitionLeaveTimeout={300}
				>
					<div key={qid} className="binary-question-text">
						{qtext}
					</div>
				</CssTransitionGroup>
				<button className="binary-question-skip" onClick={this._handleSkip}>
					<Str>Skip</Str>
				</button>
				<div className="binary-question-answers">
					<button
						className={noClasses}
						onClick={this._handleNo}
					>
						<span className="binary-question-button-text">
							<Str>No</Str>
						</span>
						<span className="binary-question-button-icon" />
					</button>
					<button
						className={yesClasses}
						onClick={this._handleYes}
					>
						<span className="binary-question-button-text">
							<Str>Yes</Str>
						</span>
						<span className="binary-question-button-icon" />
					</button>
				</div>
			</div>
		);
	}
}

export default BinaryQuestion;



// WEBPACK FOOTER //
// ./src/apps/questions/components/BinaryQuestion.jsx